export default "__VITE_ASSET__blqbs9hW__"